/**
 * Allowed merge tags for CAPA action-planning assignment emails.
 * Token text in {{Braces}} matches the underlying entity / field name used at send time.
 * Default subject/body copy is stored only in dbo.CAPAConfig
 * (ActionPlanningEmailSubjectDefault / ActionPlanningEmailBodyDefault); run SQL CAPA seed scripts to populate.
 */
export const CAPA_ACTION_PLANNING_EMAIL_MERGE_TAGS = [
  { tag: "{{CapaNo}}", entityName: "CapaNo", description: "CAPA reference number" },
  { tag: "{{Title}}", entityName: "Title", description: "CAPA title" },
  { tag: "{{Type}}", entityName: "Type", description: "Action item type (e.g. Corrective / Preventive)" },
  { tag: "{{Description}}", entityName: "Description", description: "Action planning task details" },
  { tag: "{{OwnerName}}", entityName: "OwnerName", description: "Assigned staff display name" },
  { tag: "{{DueDate}}", entityName: "DueDate", description: "Task due date" },
  { tag: "{{StartDate}}", entityName: "StartDate", description: "Task start date" },
  { tag: "{{EntityLabel}}", entityName: "EntityLabel", description: "Linked context label (if any)" },
  { tag: "{{EntityType}}", entityName: "EntityType", description: "Linked entity type (if any)" },
  { tag: "{{OrganizationName}}", entityName: "OrganizationName", description: "Organization name (when available)" },
  { tag: "{{CapaUrl}}", entityName: "CapaUrl", description: "Deep link to open the CAPA in the app" },
];

/**
 * Merge tags for accept/reject emails to the CAPA owner: same tokens and order as assignment
 * templates, plus task-decision fields. {{OwnerName}} is the CAPA owner (recipient).
 */
export const CAPA_ACTION_PLANNING_DECISION_EMAIL_MERGE_TAGS = [
  ...CAPA_ACTION_PLANNING_EMAIL_MERGE_TAGS.map((row) =>
    row.entityName === "OwnerName"
      ? {
          ...row,
          description:
            "CAPA owner display name (email recipient; same token as assignment emails)",
        }
      : row,
  ),
  {
    tag: "{{TaskAssigneeName}}",
    entityName: "TaskAssigneeName",
    description: "Staff assigned to the action-planning task",
  },
  {
    tag: "{{DecidedByName}}",
    entityName: "DecidedByName",
    description: "Staff who accepted or rejected the task",
  },
  { tag: "{{Decision}}", entityName: "Decision", description: "Accepted or Rejected" },
  {
    tag: "{{DecisionReason}}",
    entityName: "DecisionReason",
    description: "Reason entered when accepting or rejecting",
  },
];

/**
 * @param {string} template
 * @param {Record<string, string>} values keys = entity names (e.g. CapaNo, Title)
 */
export function applyCapaActionPlanningEmailTemplate(template, values) {
  if (!template || !values) return template || "";
  let out = template;
  Object.keys(values).forEach((key) => {
    if (!key) return;
    out = out.split(`{{${key}}}`).join(values[key] != null ? String(values[key]) : "");
  });
  return out;
}
